import React from 'react';
import { Box, BoxProps, Grid, Stack, Typography } from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import { TP_COLORS } from '../../../../constants';
import { getSubmissionsV2State } from '../../../../store/V2/SubmissionsSlice';
import { msToMinutesSeconds } from '../../../../helper';
import PerformanceTabs from './PerformanceTabs';
import NoData from '../../../../components/V2/Empty/NoData';
import BasicLoader from '../../../../components/Loaders/BasicLoader';

const boxProps: BoxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  minHeight: '104px',
  borderRadius: '16px',
  boxShadow: '0px 12px 24px -4px #919EAB1A',
};

const StudentPerformance: React.FC = () => {
  // Store
  const {
    courseSubmissionsData,
    studentSubmissionsData,
    status,
  } = useAppSelector(getSubmissionsV2State);

  return (
    <>
      {!studentSubmissionsData && status === 'loading' ? (
        <BasicLoader
          containerProps={{
            minHeight: '300px',
            alignItems: 'center',
          }}
        />
      ) : null}

      {studentSubmissionsData?.groupedSubmissions.length === 0 ? (
        <NoData title="No submissions found" />
      ) : null}

      {studentSubmissionsData?.groupedSubmissions.length ? (
        <Stack>
          <Box margin="32px 0">
            <Grid container spacing={4}>
              <Grid item xs={12} sm={4} md={3}>
                <Box
                  sx={{
                    backgroundColor: TP_COLORS.gray.darken,
                    borderRadius: '20px',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    color={TP_COLORS.typo.white}
                    textAlign="center"
                    padding="5px 0"
                  >
                    Class (avg) -{' '}
                    {courseSubmissionsData?.totalAverageScore || 0}
                    /20
                  </Typography>
                  <Box
                    {...boxProps}
                    sx={{
                      background: `url('${process.env.PUBLIC_URL}/images/quizPerformance/shape-green.png') right center/contain no-repeat, #fff`,
                    }}
                  >
                    <Box>
                      <Typography fontSize="18px">
                        Score <span style={{ fontSize: '12px' }}>(avg)</span>
                      </Typography>
                      <Typography fontSize="30px" fontWeight="700">
                        {studentSubmissionsData.totalAverageScore || 0}/20
                      </Typography>
                    </Box>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/quizPerformance/icon-cup.png`}
                      alt="subject-img"
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={4} md={3}>
                <Box
                  sx={{
                    backgroundColor: TP_COLORS.gray.darken,
                    borderRadius: '20px',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    color={TP_COLORS.typo.white}
                    textAlign="center"
                    padding="5px 0"
                  >
                    Class (avg) -{' '}
                    {msToMinutesSeconds(
                      courseSubmissionsData?.totalAverageTime || 0
                    )}
                  </Typography>
                  <Box
                    {...boxProps}
                    sx={{
                      background: `url('${process.env.PUBLIC_URL}/images/quizPerformance/shape-purple.png') right center/contain no-repeat, #fff`,
                    }}
                  >
                    <Box>
                      <Typography fontSize="18px">
                        Time Taken{' '}
                        <span style={{ fontSize: '12px' }}>(avg)</span>
                      </Typography>
                      <Typography fontSize="30px" fontWeight="700">
                        {msToMinutesSeconds(
                          studentSubmissionsData?.totalAverageTime || 0
                        )}
                      </Typography>
                    </Box>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/quizPerformance/icon-timer.png`}
                      alt="subject-img"
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <PerformanceTabs />
        </Stack>
      ) : null}
    </>
  );
};

export default StudentPerformance;
